/*
  $route.path 字符串，等于当前路由对象的路径，会被解析为绝对路径，如 '/home/news' 。
  $route.params 对象，包含路由中的动态片段和全匹配片段的键值对
  $route.query 对象，包含路由中查询参数的键值对。例如，对于 /home/news/detail/01?favorite=yes ，会得到$route.query.favorite == 'yes' 。
  $route.router 路由规则所属的路由器（以及其所属的组件）。
  $route.matched 数组，包含当前匹配的路径中所包含的所有片段所对应的配置参数对象。它会将嵌套它的父路由都匹配出来。
  $route.name  当前路径的名字，如果没有使用具名路径，则名字为空。
*/
import Vue from 'vue'
import home from '@/common/area/home'
import register from '@/common/area/register'
/* eslint-disable */
import Router from 'vue-router'
import frontViews from '@/router/views.js';
import AdminRouter from '@/router/admin.js';
import {
  localStorage
} from '@/common/util/storage';

let mainRouter = [{
    path: '/',
    redirect: {
      path: '/home'
    },
    meta: {
      title: '联盟官网首页'
    },
    component: home
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '用户注册'
    },
    component: register
  },
  ...frontViews,
  ...AdminRouter
]
Vue.use(Router)
const router = new Router({
  routes: mainRouter,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  }
})

// router.beforeEach((to, from, next) => {
//   let token = localStorage.get('token');
//   if (!token) {
//     if (to.path !== '/home') {
//       next({
//         path: '/home',
//         query: {
//           redirect: to.fullPath
//         } // 将跳转的路由path作为参数，用于在登录成功后获取并跳转到该路径
//       })
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js